<script lang="ts">

    export let text: string;
</script>


<div on:click|stopPropagation class="link">
    {text}
</div>


<style>
    .link {
        color: var(--automapa-blue-dark);
        cursor: pointer;
        text-decoration: underline;
        font-weight: 500
    }
</style>

